import { ScoopTextField, ScoopButton, ScoopDialog, ScoopText, ScoopSelector } from '../../../../components/ui'
import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import styles from './APIFilterField.module.scss'

export const APIFilterField = ({
    APIFeatures,
    filterMap,
    filterModalOpen,
    setFilterModalOpen,
    onFilterModalClose,
    filterField,
    setFilterField,
    operator,
    setOperator,
}) => {
    const [value, setValue] = React.useState(null)
    const [values, setValues] = React.useState([])

    // Build operator options based on field type and API features
    const getOperatorOptions = () => {
        const options = []

        if (filterField.fieldType !== 'DateTime') {
            if (APIFeatures.supportedFilterOperators.includes('Equals')) {
                options.push({ label: 'Equals', value: 'Equals' })
            }
            if (APIFeatures.supportedFilterOperators.includes('NotEquals')) {
                options.push({ label: 'Not Equals', value: 'NotEquals' })
            }
            if (APIFeatures.supportedFilterOperators.includes('In')) {
                options.push({ label: 'In', value: 'In' })
            }
            if (APIFeatures.supportedFilterOperators.includes('NotIn')) {
                options.push({ label: 'Not In', value: 'NotIn' })
            }
        } else {
            options.push({ label: 'Last Day', value: 'LastDay' })
            options.push({ label: 'Last Week', value: 'LastWeek' })
            options.push({ label: 'Last Month', value: 'LastMonth' })
            options.push({ label: 'Last Year', value: 'LastYear' })
        }

        return options
    }

    return (
        <ScoopDialog
            open={filterModalOpen}
            onClose={onFilterModalClose}
            actions={
                <>
                    <ScoopButton
                        variant="text"
                        size="sm"
                        onClick={() => {
                            setFilterModalOpen(false)
                            setFilterField(null)
                            setValues([])
                        }}
                    >
                        Cancel
                    </ScoopButton>
                    <ScoopButton
                        size="sm"
                        disabled={
                            (!values || values.length === 0) &&
                            filterField.fieldType !== 'DateTime' &&
                            !value
                        }
                        onClick={() => {
                            if (operator === 'In' || operator === 'NotIn') {
                                let newValues = []
                                for (let i = 0; i < values.length; i++) {
                                    newValues.push(values[i].value)
                                }
                                filterMap.set(filterField.name, {
                                    operator: operator,
                                    values: newValues,
                                })
                            } else {
                                filterMap.set(filterField.name, {
                                    operator: operator,
                                    values: [value],
                                })
                            }
                            setFilterModalOpen(false)
                            setValues([])
                        }}
                    >
                        Set Filter
                    </ScoopButton>
                </>
            }
        >
            <ScoopText className={styles.filterTitle}>Filter on field {filterField.label}</ScoopText>
            <div className={styles.filterContainer}>
                <ScoopSelector
                    className={styles.operatorSelector}
                    value={operator}
                    onChange={(event) => {
                        setOperator(event.target.value)
                    }}
                    options={getOperatorOptions()}
                />
                {filterField.fieldType !== 'DateTime' && (
                    <ScoopTextField
                        onChange={(event) => {
                            setValue(event.target.value)
                        }}
                    />
                )}
                {(operator === 'In' || operator === 'NotIn') && (
                    <ScoopButton
                        size="sm"
                        className={styles.addButton}
                        onClick={(event) => {
                            let newValues = []
                            let id = 0
                            for (let i = 0; i < values.length; i++) {
                                newValues.push({
                                    id: i,
                                    value: values[i].value,
                                })
                            }
                            newValues.push({ id: values.length, value: value })
                            setValues(newValues)
                        }}
                    >
                        Add
                    </ScoopButton>
                )}
            </div>
            {(operator === 'In' || operator === 'NotIn') && values && (
                <DataGrid
                    autoHeight
                    columns={[
                        {
                            field: 'value',
                            headerName: 'Value',
                            type: 'string',
                            sortable: false,
                            editable: false,
                            width: '100%',
                            headerAlign: 'center',
                        },
                    ]}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                page: 0,
                                pageSize: 10,
                            },
                        },
                    }}
                    rows={values}
                    rowHeight={25}
                    onRowSelectionModelChange={(ids) => { }}
                    sx={{
                        '& .MuiDataGrid-columnHeaders': {
                            display: 'none',
                        },
                    }}
                />
            )}
        </ScoopDialog>
    )
}
